// import Cookies from 'js-cookie'
import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import { languageList } from '@/lang'
import Cookies from 'js-cookie'
import store from '@/store'

// 获取cookies 中的列（JSON.stringify 对 方法直接过滤）
export function getCookieHead(vuename, headerAll) {
  var header = []
  //
  if (getCookie(vuename)) {
    JSON.parse(getCookie(vuename)).forEach(element => {
      headerAll.forEach(elementIn => {
        if (element.prop === elementIn.prop) {
          header.push(elementIn)
        }
      })
    })
  }
  return header.length > 0 ? header : ''
}
// excel导出的数据
export function exportExcel(url, params, name) {
  axios({
    method: 'post',
    url: window.glob.baseUrl + url,
    headers: {Authorization: JSON.parse(sessionStorage.getItem('token'))},
    data: qs.stringify(params),
    responseType: 'blob'
  }).then(res => {
    // 技术文档资料库
    let link = document.createElement('a')
    link.href = URL.createObjectURL(res.data)
    link.setAttribute('download', name)
    link.click()
    link = null
  })
}
// 获取cookies
export function getCookie(cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(name) !== -1) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}
// 更改时间格式
export function getTime(date) {
  var dateStr = ''
  date = new Date(date)
  var yy = date.getFullYear()
  var mm = parseInt(date.getMonth()) + 1
  var dd = parseInt(date.getDate())
  var hh = date.getHours()
  var min = date.getMinutes()
  var ss = date.getSeconds()
  if (mm < 10) {
    mm = '0' + mm
  }
  if (dd < 10) {
    dd = '0' + dd
  }
  if (hh < 10) {
    hh = '0' + hh
  }
  if (min < 10) {
    min = '0' + min
  }
  if (ss < 10) {
    ss = '0' + ss
  }
  dateStr = yy.toString() + '-' + mm + '-' + dd + ' ' + hh + ':' + min + ':' + ss
  return dateStr
}
export function dateFormatter(date) {
  var d = new Date(date)
  var dateF = d.getFullYear() + '-' + ((d.getMonth() + 1) > 9 ? (d.getMonth() + 1) : '0' + (d.getMonth() + 1)) + '-' + (d.getDate() > 9 ? d.getDate() : '0' + d.getDate())
  return dateF
}
export var pickerOptions = {
  // shortcuts: [{
  //   text: '今天',
  //   onClick(picker) {
  //     picker.$emit('pick', new Date())
  //   }
  // }, {
  //   text: '昨天',
  //   onClick(picker) {
  //     const date = new Date()
  //     date.setTime(date.getTime() - 3600 * 1000 * 24)
  //     picker.$emit('pick', date)
  //   }
  // }, {
  //   text: '一周前',
  //   onClick(picker) {
  //     const date = new Date()
  //     date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
  //     picker.$emit('pick', date)
  //   }
  // }]
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return [ '日', '一', '二', '三', '四', '五', '六' ][ value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}
// 处理系统字典configVal为多语言
export function dealConfigVal(data) {
  data.forEach(value => {
    let dealData = JSON.parse(value.configVal)
    value.configValList = []
    // 按languageList的index,往configValList里赋值（用于表格循环展示，编辑时循环展示）
    languageList.forEach((val, index) => {
      if (dealData) {
        let findData = dealData.find(ele => ele.language === val.language)
        if (findData) {
          value.configValList[index] = findData.configVal
          if (findData.language === store.state.app.language) {
            value.optionsLabel = findData.configVal // 下拉框，需区分当前语言
          }
        } else {
          value.configValList[index] = ''
        }
      } else {
        value.configValList[index] = ''
      }
    })
  })
}

// 中文时间转英文
export function zhDateChangeEn(value) {
  // 非英文的时候才去转
  if (Cookies.get('language') !== 'zh' && value) {
    var arry = []
    var dateStr = []
    arry = value.split(' ')
    dateStr = arry[0].split('-')
    value = dateStr[1] + '/' + dateStr[2] + '/' + dateStr[0] + ' ' + arry[1]
  }
  return value
}

// 考试花费时间格式化补0
export const getNumberPrefix = data => data > 9 ? data : '0' + data

export default new Vue() // 用同一个vue实例作为中转站。通过一个方法来调用另一个组件的方法



// WEBPACK FOOTER //
// ./src/utils/index.js